import { ReactElement, useCallback } from 'react';
import { ConfirmationModal } from '@components/conductedMeetings/confirmationModal/confirmationModal';

const CONSENT_MESSAGE = 'This conversation will be recorded';

const SPEECH_SYNTHESIS_SUPPORTED = 'This conversation will be recorded for training and feedback purpose';
interface SiteVisitRecordingInfoModalProps {
	onAcknowledge: () => void;
	onDismiss: () => void;
}

/** Informational popup shown before starting a site visit (recording notice). */
export function SiteVisitRecordingConsentModal({
	onAcknowledge,
	onDismiss,
}: Readonly<SiteVisitRecordingInfoModalProps>): ReactElement {
	const handleAcknowledge = useCallback((): void => {
		if ('speechSynthesis' in window) {
			const utterance = new SpeechSynthesisUtterance(SPEECH_SYNTHESIS_SUPPORTED);
			utterance.lang = 'en-US';
			speechSynthesis.speak(utterance);
		}
		onAcknowledge();
	}, [onAcknowledge]);

	return (
		<ConfirmationModal
			onClose={onDismiss}
			onSubmit={handleAcknowledge}
			message={CONSENT_MESSAGE}
			hideCancelButton
			buttonLabel="Ok"
		/>
	);
}
